import apiClient from './client';
import { clearStoredAuthProvider } from '../../auth/msalService';

/**
 * Authentication API service
 */

/**
 * Login with username and password
 * @param {string} username
 * @param {string} password
 * @returns {Promise<{access_token: string}>}
 */
export async function login(username, password) {
  const response = await apiClient.post('/login', {
    username,
    password,
  });
  return response.data;
}

/**
 * Logout (client-side only, clears token)
 */
export function logout() {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('role');
  localStorage.removeItem('username');
  clearStoredAuthProvider();
}

/**
 * Get stored token
 * @returns {string|null}
 */
export function getToken() {
  return localStorage.getItem('accessToken');
}

/**
 * Store token and user info
 * @param {string} token
 * @param {Object} userData
 */
export function setToken(token, userData = {}) {
  localStorage.setItem('accessToken', token);
  if (userData.role) {
    localStorage.setItem('role', userData.role);
  }
  if (userData.username) {
    localStorage.setItem('username', userData.username);
  }
}

/**
 * Parse JWT token to get payload
 * @param {string} token
 * @returns {Object|null}
 */
export function parseJWT(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
}
